import { useContext } from 'react';
import { ConversationRefreshContext } from '../contexts/ConversationRefreshContext';

export const useConversationRefresh = () => {
  const context = useContext(ConversationRefreshContext);
  
  if (!context) {
    throw new Error('useConversationRefresh must be used within ConversationRefreshProvider');
  }
  
  return context;
};